<template>
  <TransitionGroup
    name="alert"
    tag="div"
    enter-from-class="opacity-0 h-0"
    enter-to-class="opacity-100 h-[40px]"
    leave-from-class="opacity-100 h-[40px]"
    leave-to-class="opacity-0 h-0"
    enter-active-class="transition ease-out duration-500"
    leave-active-class="transition ease-in duration-500"
    move-class="transition-all duration-500"
    class="sticky inset-x-0 block items-center"
  >
    <AuthErrorToast
      v-if="alert"
      :key="alert.id"
      :alert="alert"
      data-test-id="toast-info"
      class="w-full transition-all duration-500"
    />
  </TransitionGroup>
</template>

<script setup lang="ts">
const { $alert } = useNuxtApp()
const alert = computed(() => $alert.authErrorAlert.value)
</script>
